import { DEFAULT_TLD } from './DomainSearchForm.constants';
export function ensureTLD(domain) {
  if (!domain) {
    return '';
  }

  var re = /[^.]*\.[^.]{2,3}(?:\.[^.]{2,3})?$/;
  var match = domain.match(re);
  return !match ? "".concat(domain).concat(DEFAULT_TLD) : match[0];
}
export function hasMoreResults(resultCount, currentNumResultsShow) {
  return resultCount > 0 && resultCount > currentNumResultsShow;
}